/**
 * Show Background Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.showBackgroundFormatter = function(value, row) {
    if (value === null || value === undefined) {
        return '<span class="text-muted">'+__('N/A')+'</span>';
    }

    let domainId = $('#domain_id').val();
    let pageId = $('#page_id').val();
    let url = '/domains/show/pages/show/modules/toggle/' + domainId + '/' + pageId + '/' + row.id;

    return toggleableFormatter(value, row, 'show_background', url);
};
